import React from "react";
import "./App.scss";
import Main from "./containers/Main";

function App() {
  return (
    <div className="app-container" role="main">
      <Main />
    </div>
  );
}

export default App;
